import React, { useState } from 'react';
import { useQueryClient } from 'react-query';
import {
  DeleteMessage,
  ModalButtonWrapper,
  OutlineButton,
} from '../../../../services/settings/appStyle/global.style';
import Modal from '../../../../Components/uielements/modal';
import { IntlMessages } from '../../../../helper/langHelper';
import { Button } from '../../../../Components/uielements';
import { AccountDeleteModalWrapper } from '../company.style';
import { Input } from '../../LoginV2/Login.style';
import { deleteMyCompany } from '../../../../services/bioplus-services/company';
import { useNavigate } from 'react-router-dom';

const AccountDeleteConfirmation = ({
  onClose,
  title = <IntlMessages id="text.delete.confirmation" />,
  buttonDeleteText = <IntlMessages id="modal.button.delete" />,
  isAdminAndPartner = false,
  companyId,
}) => {
  const [confirmText, setConfirmText] = useState('');
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleConfirmChange = (event) => {
    const { value } = event.target;
    setConfirmText(value);
    setIsButtonEnabled(value === 'confirm');
  };

  const handleConfirmDelete = async () => {
    try {
      await deleteMyCompany(isAdminAndPartner ? { companyId } : undefined);
      if (isAdminAndPartner) {
        queryClient.invalidateQueries(['adminCompanies']);
        onClose();
      } else {
        navigate('/signout');
      }
    } catch (error) {
      alert('We were unable to delete your account. Please try again later.');
    }
  };

  return (
    <>
      <Modal isOpen={true} onClose={onClose} title={title}>
        <AccountDeleteModalWrapper>
          <DeleteMessage>
            Are you sure you want to delete your account? Once you delete it, you will not be able
            to use this account again, as it will be permanently deleted.
          </DeleteMessage>

          <DeleteMessage style={{ paddingTop: '15px', paddingBottom: '15px' }}>
            If you want to proceed with the deletion, please type the word{' '}
            <span style={{ fontWeight: 'bold' }}>"confirm" </span> in the input box below and press
            the delete button.
          </DeleteMessage>

          <Input
            type="text"
            placeholder="confirm"
            value={confirmText}
            onChange={handleConfirmChange}
          />

          <ModalButtonWrapper>
            <OutlineButton onClick={onClose}>
              <IntlMessages id="modal.button.close" />
            </OutlineButton>
            <Button varient="normal" onClick={handleConfirmDelete} disabled={!isButtonEnabled}>
              {buttonDeleteText}
            </Button>
          </ModalButtonWrapper>
        </AccountDeleteModalWrapper>
      </Modal>
    </>
  );
};

export default AccountDeleteConfirmation;
